import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const NLineTrends = (props) => {
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const [NPTrends, SetNPTrends] = useState();

  const NationalPerformanceTrends = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/InstitutionAdmin/GetNationalPerformanceTrendsByInstitute?Year=${USYear?.value}&AssessmentType=${props.AType}&InstituteId=${items?.instituteId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].assessmentDate) {
          SetNPTrends(res.data);
          const subjects = [
            ...new Set(res.data.map((item) => item.subjectName)),
          ];
          props.StoreSubjects(subjects);
          props.StoreSelSub(subjects[0]);
        } else {
          SetNPTrends(process.env.REACT_APP_NODATAFOUND_Participated);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if(props.AType){
      NationalPerformanceTrends();
    }
  }, [USYear,props.AType]);

  const labels = [];
  const subjectsData = {};

  if (NPTrends?.[0]?.assessmentDate) {
    NPTrends?.forEach((item) => {
      if (
        !labels.includes(item.assessmentDate) &&
        props.SubSelect === item.subjectName
      ) {
        labels.push(item.assessmentDate);
      }
      if (!subjectsData[item.section]) {
        subjectsData[item.subjectName] = [];
      }
    });

    NPTrends?.forEach((item) => {
      subjectsData[item.subjectName].push(item.percentage);
    });
  }

  const datasets = Object.keys(subjectsData).map((Subject) => ({
    label: Subject,
    data: subjectsData[props.SubSelect],
    backgroundColor:
      {
        English: "#7C60BC",
        Mathematics: "#00A2B9",
        Science: "#3DA663",
        Biology: "#F7C66A",
        BioTechnology: "#A63D95",
        "Physics and Chemistry": "#3B9ED7",
      }[(Subject, props.SubSelect)] || "#000",
    borderColor:
      {
        English: "#7C60BC",
        Mathematics: "#00A2B9",
        Science: "#3DA663",
        Biology: "#F7C66A",
        BioTechnology: "#A63D95",
        "Physics and Chemistry": "#3B9ED7",
      }[(Subject, props.SubSelect)] || "#000",

    // #3B9ED7 - P & C
    // #F7C66A - b
    // #A63D95 - bt

    maxBarThickness: 40,
    barThickness: 45,
  }));

  const data = { labels: labels, datasets: datasets };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            if (context.dataset.label === props.SubSelect) {
              const label = context.dataset.label || "";
              const value =
                context.parsed.y !== null ? context.parsed.y + "%" : "";
              return `${label}: ${value}`;
            }
            return null;
          },
        },
      },
    },
    scales: {
      x: {
        offset: 20,
        grid: { display: false },
        title: { display: true, text: "Assessment Date" },
      },
      y: {
        beginAtZero: true,
        max: 100,
        title: { display: true, text: "Performance %" },
      },
    },
  };

  return (
    <>
      <div className="SubHeading">National performance</div>
      {NPTrends?.[0]?.assessmentDate ? (
        <>
          <div style={{ marginTop: "44px" }}> </div>
          <Line options={options} data={data} />{" "}
        </>
      ) : (
        <div className="ErrorMessage">{NPTrends}</div>
      )}
    </>
  );
};
export default NLineTrends;
